import { VideoStyle } from "./../styles/Videos";

function Home() {
    return (
        <div className="Home"> 
            <VideoStyle/>
            <h2>Tuinfeest 2022 - Linthorst Techniek</h2>
            <iframe src="https://www.youtube.com/embed/K1lvGR6wkac" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <br></br>
            <hr></hr>
            {/* <h2>Video's</h2> */}
            {/* @foreach (VideoModel videoModel in ViewBag.Videos)
            {
                <div class="video-container">
                    <div id="thumbnail">
                        <img @*src="https://i.imgur.com/4d71yI0.jpeg"*@ src="@videoModel.ImagePath" alt="thumbnail" width="356" height="200">
                    </div>
                    @Html.ActionLink(videoModel.Title, "Response", "Home", videoModel, new { id = "title" })
                    <div id="doc">@videoModel.Info</div>
                    <div id="responses">Aantal reacties: @videoModel.Responses</div>
                </div>
            } */}
        </div>
    );
}

export default Home;